export enum NotificationType {
    UnrepliedEmail = 'UnrepliedEmail',
    ShareProposal = 'ShareProposal',
    ShareAcknowledgment = 'ShareAcknowledgment',
    ShareMarketingUpdate = 'ShareMarketingUpdate',
    Manual = 'Manual',
    RemarketUpdate = 'RemarketUpdate',
}
